<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "新建回款单" : "回款单编辑" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='700'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="回款编号"
                  readonly
                  hide-details='auto'
                  outlined
                  :rules="required"
                  v-model="form.returnNumber">
                  <template v-slot:append>
                    <v-btn fab x-small :disabled="isEdit || item.returnNumber !== ''" color="blur-grey" dark @click='returnNumber' class="mt-n1 mr-n4">
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="returnedMoneyStateItems"
                  label="回款状态"
                  v-model="form.returnStateId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
               <v-select
                 :items="returnedMoneyTypeItems"
                 label="回款类型"
                 v-model="form.returnTypeId"
                 hide-details='auto'
                 outlined
                 item-text='name'
                 item-value="id"
                 :rules="required"
               ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="回款单位" hide-details='auto' outlined :rules="required" v-model="form.returnFrom"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="回款金额" hide-details='auto' outlined :rules="number" v-model="form.money"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
               <base-material-date
                  ref='date'
                  :rules="required"
                  hide-details='auto'
                  outlined
                  label='回款时间'
                  v-model='form.returnTimeStr'
                >
                </base-material-date>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="bankAccountItems"
                  label="收款账户"
                  v-model="form.returnAccountId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
               <v-select
                 :items="returnedMoneyPayTypeItems"
                 label="支付方式"
                 v-model="form.payTypeId"
                 hide-details='auto'
                 outlined
                 item-text='name'
                 item-value="id"
                 :rules="required"
               ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea rows='4' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>

          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/contract/returned.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { serialNumber, isEmpty } from '@/utils/stringUtil.js'

  export default {
    name: 'ReturnAdd',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          type: 1, // 1. 直接保存2.传值到父页面
          data: null,
          contractId: '',
          collectId: '',
          customerName: '',
          returnNumber: ''
        })
      },
      surplusMoney: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && value <= this.surplusMoney) || `金额必填且不得超过${this.surplusMoney}`,
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        form: {
          id: '',
          contractId: '',
          collectId: '',
          returnNumber: '',
          returnTypeId: '',
          returnStateId: this.$constants.ReturnedMoneyState.GET_MONEY_ID,
          returnFrom: '',
          money: '',
          ratioPrice: '',
          returnTimeStr: '',
          returnTime: '',
          returnAccountId: '',
          payTypeId: '',
          remrk: ''
        },
        defForm: {
          id: '',
          contractId: '',
          collectId: '',
          returnNumber: '',
          returnTypeId: '',
          returnStateId: this.$constants.ReturnedMoneyState.GET_MONEY_ID,
          returnFrom: '',
          money: '',
          ratioPrice: '',
          returnTimeStr: '',
          returnTime: '',
          returnAccountId: '',
          payTypeId: '',
          remrk: ''
        },
        returnedMoneyTypeItems: [],
        returnedMoneyStateItems: [],
        returnedMoneyPayTypeItems: [],
        bankAccountItems: []
      }
    },
    methods: {
      save () {
        this.builSubForm()
        if (this.$refs.form.validate()) {
          if (this.item.type === 2) {
            this.item.show = false
            this.$emit("on-submit", JSON.parse(JSON.stringify(this.form)))
          } else {
            this.loading = true
            save(this.form).then(res => {
              if (res.status === 200) {
                this.item.show = false
                this.$emit("on-load-data")
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          }
        }
      },
      builSubForm () {
        this.form.returnTime = new Date(this.form.returnTimeStr).getTime() / 1000
      },
      returnNumber () {
        this.form.returnNumber = isEmpty(this.item.returnNumber) ? serialNumber('YD.', '.HK') : this.item.returnNumber
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          } else {
            this.form = JSON.parse(JSON.stringify(this.defForm))
            this.returnNumber()
            this.form.personList = [
              {
                id: this.$store.state.userInfo.id,
                name: this.$store.state.userInfo.name,
                uid: this.$store.state.userInfo.userId
              }
            ]
            this.form.contractId = this.item.contractId
            this.form.collectId = this.item.collectId
            this.form.returnFrom = this.item.customerName
          }
        } else {
          this.$refs.form.resetValidation()
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.returnedMoneyTypePid,
              this.$constants.returnedMoneyStatePid,
              this.$constants.returnedMoneyPayTypePid,
              this.$constants.bankAccountPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.returnedMoneyTypePid === result.id) {
                this_.returnedMoneyTypeItems = result.data
             } else if (this_.$constants.returnedMoneyStatePid === result.id) {
                this_.returnedMoneyStateItems = result.data
             } else if (this_.$constants.returnedMoneyPayTypePid === result.id) {
               this_.returnedMoneyPayTypeItems = result.data
             } else if (this_.$constants.bankAccountPid === result.id) {
               this_.bankAccountItems = result.data
             }
           })
          }
        })
      },
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created () {
      this.getTypes()
    }
  }
</script>

<style>
</style>
